/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useParams } from 'react-router'
import { DocumentsListPage } from './DocumentsListPage'
import { DOCUMENTS_VIEW_TYPE } from './types'

export const RegulatedContentPage: React.FC = () => {
  const { folderId } = useParams<{ folderId: string }>()

  return (
    <DocumentsListPage
      key={`regulatedContent-${folderId || 'root'}`}
      viewType={DOCUMENTS_VIEW_TYPE.regulatedContent}
      folderId={folderId}
    />
  )
}
